export const getDataTypeName = (dataTypeEnum?: string) => {
  if (dataTypeEnum === 'INTEGER') {
    return 'Sayı';
  } else if (dataTypeEnum === 'DOUBLE') {
    return 'Ondalıklı sayı';
  } else if (dataTypeEnum === 'STRING') {
    return 'Metin';
  } else if (dataTypeEnum === 'TEXT') {
    return 'Uzun metin';
  } else if (dataTypeEnum === 'PICKLIST') {
    return 'Çoktan seçmeli';
  } else if (dataTypeEnum === 'MULTIPICKLIST') {
    return 'Çoktan seçmeli (çoklu)';
  } else if (dataTypeEnum === 'BOOLEAN') {
    return 'Evet / Hayır';
  } else if (dataTypeEnum === 'DATE') {
    return 'Tarih';
  } else if (dataTypeEnum === 'DATETIME') {
    return 'Tarih saat';
  } else if (dataTypeEnum === 'TIME') {
    return 'Saat';
  } else if (dataTypeEnum === 'DECIMAL') {
    return 'Para';
  } else if (dataTypeEnum === 'URL') {
    return 'URL';
  } else if (dataTypeEnum === 'FOREIGNKEY') {
    return 'Referans';
  } else if (dataTypeEnum === 'MULTIFOREIGNKEY') {
    return 'Çoklu referans';
  }  else if (dataTypeEnum === 'LOOKUP') {
    return 'Arama';
  } else if (dataTypeEnum === 'DYNAMIC') {
    return 'Otomatik';
  } else if (dataTypeEnum === 'RULEBASED') {
    return 'Koşullu otomatik';
  } else if (dataTypeEnum === 'PARENTROW') {
    return 'Üst-alt ilişkisi';
  } else if (dataTypeEnum === 'AUTOINC') {
    return 'Sayaç';
  } else if(dataTypeEnum === 'SUBGRID') {
    return 'Alt tablo';
  } else if (dataTypeEnum === 'FILE_UPLOAD') {
    return 'Dosya yükleme';
  }
  return null;
};
